import { render, staticRenderFns } from "./product-sort-modal.vue?vue&type=template&id=a80ad3d4&scoped=true&"
import script from "./product-sort-modal.vue?vue&type=script&lang=js&"
export * from "./product-sort-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ad3d4",
  null
  
)

export default component.exports